import React from 'react';

import { Layout } from '@components/Layout';
import { Container } from '@components/utilities/BookingInquiry/Container';
import { PriceSimulatorForm } from '@components/utilities/PriceSimulator/PriceSimulatorForm';
import { meta } from '@pages/utilities/PriceSimulator/PriceSimulator.pagemeta';

export const PriceSimulator: React.FC = () => {
  return (
    <Layout
      title={meta.title!}
      breadcrumbs={['/utilities/Dashboard', '/utilities/PriceSimulator/PriceSimulator']}
    >
      <Container>
        <PriceSimulatorForm />
      </Container>
    </Layout>
  );
};
